<template>
  <ValidationObserver ref="confirmAdjustmentDialog">
    <BaseDialog :isOpen="true">
      <template v-slot:title>
        Confirm Adjustment
      </template>
      <template v-slot:body>
        <ValidationProvider v-slot="{ errors }" name="comment">
          {{ label }}
          <v-textarea
            :error-messages="showValidationErrors ? errors : ''"
            v-model="comment"
            height="180"
            color="primary"
            placeholder="Add comment..."
            class="mt-0"
          />
        </ValidationProvider>
      </template>
      <template v-slot:actions>
        <div>
          <PrimaryButton @click.native="close" text>
            Cancel
          </PrimaryButton>
          <PrimaryButton @click.native="handleClick" :loading="isLoading">
            Confirm
          </PrimaryButton>
        </div>
      </template>
    </BaseDialog>
  </ValidationObserver>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { copyState } from "@/utils/helpers";
import { INTERVIEWS_NAMESPACE } from "@/store/modules/bookings/interviews";
import {
  EDIT_INTERVIEW_PARTICIPANT,
  FETCH_INTERVIEW_SLOT
} from "@/store/modules/bookings/interviews/actions";
import { createNamespacedHelpers } from "vuex";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { getCurrentParticipantId } from "@/views/bookings/BookingInterviews/modules/utils";
import { DATA_NAMESPACE } from "@/store/modules/data";
import { ADD_COMMENT } from "@/store/modules/data/actions";

const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);

const { mapActions: mapDataActions } = createNamespacedHelpers(DATA_NAMESPACE);

const {
  mapActions: mapInterviewActions,
  mapState: mapInterviewState
} = createNamespacedHelpers(INTERVIEWS_NAMESPACE);

export default {
  name: "ConfirmAdjustmentDialog",
  components: {
    PrimaryButton,
    BaseDialog,
    ValidationObserver,
    ValidationProvider
  },
  props: {
    label: String
  },
  data() {
    return {
      isLoading: false,
      showValidationErrors: false,
      comment: ""
    };
  },
  computed: {
    ...mapAuthState({
      userData: state => state.userData
    }),
    ...mapInterviewState(copyState(["currentInterviewSlot"])),
    currentInterviewId() {
      return this.$route.params.interviewId;
    }
  },
  methods: {
    ...mapInterviewActions({
      editInterviewParticipant: EDIT_INTERVIEW_PARTICIPANT,
      fetchInterviewSlot: FETCH_INTERVIEW_SLOT
    }),
    ...mapDataActions({
      addComment: ADD_COMMENT
    }),
    async handleClick() {
      this.showValidationErrors = true;
      const isFormValid = await this.$refs.confirmAdjustmentDialog.validate();
      if (isFormValid) {
        this.isLoading = true;
        const participantId = getCurrentParticipantId({
          userId: this.userData.id,
          participants: this.currentInterviewSlot.participants
        });
        await this.editInterviewParticipant({
          interviewId: this.currentInterviewId,
          participantId,
          data: { adjustmentForConfirmed: true }
        });
        await this.addComment({
          body: this.comment,
          commentableType: "interview_slot",
          commentableId: this.currentInterviewId
        });
        this.fetchInterviewSlot(this.currentInterviewId);
        this.isLoading = false;
        this.close();
      }
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
